const baseProps = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
};

export const IconSparkles = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M12 3 13.6 8.4 19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6Z" />
		<path d="M19 16v4" />
		<path d="M17 18h4" />
		<path d="M5 3v3" />
		<path d="M3.5 4.5h3" />
	</svg>
);

export const IconClose = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M18 6 6 18" />
		<path d="m6 6 12 12" />
	</svg>
);

export const IconTrash = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M3 6h18" />
		<path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
		<path d="M19 6l-1 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1L5 6" />
		<path d="M10 11v6" />
		<path d="M14 11v6" />
	</svg>
);

export const IconSend = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M22 2 11 13" />
		<path d="M22 2 15 22l-4-9-9-4Z" />
	</svg>
);

export const IconUser = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
		<circle cx="12" cy="7" r="4" />
	</svg>
);

export const IconCheck = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M20 6 9 17l-5-5" />
	</svg>
);

export const IconAlert = (props) => (
	<svg {...baseProps} {...props}>
		<circle cx="12" cy="12" r="10" />
		<path d="M12 8v4" />
		<path d="M12 16h.01" />
	</svg>
);

export const IconLoader = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M21 12a9 9 0 1 1-6.219-8.56" />
	</svg>
);
